import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormInputFileComponent } from './form-input-file.component';
import { FileUploadModule } from 'primeng/fileupload';
import { SharedModule } from '../../../modules/shared/shared.module';
import { FormInputErrorModule } from '../form-input-error/form-input-error.module';

@NgModule({
  declarations: [
    FormInputFileComponent
  ],
  imports: [
    CommonModule,
    FileUploadModule,
    SharedModule,
    FormInputErrorModule,
  ],
  exports: [
    FormInputFileComponent
  ]
})
export class FormInputFileModule { }
